import { AlertTriangle } from 'lucide-react';
import Modal from './Modal';
import Button from './Button';

/**
 * ConfirmModal - Silme/onay modalı
 * 
 * @param {boolean} isOpen - Modal açık mı
 * @param {function} onClose - Kapatma
 * @param {function} onConfirm - Onay
 * @param {string} title - Başlık
 * @param {string} message - Mesaj
 * @param {string} confirmText - Onay butonu yazısı
 * @param {string} cancelText - İptal butonu yazısı
 * @param {string} variant - Buton varyantı (danger, warning, primary)
 */
export default function ConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    title = 'Emin misiniz?',
    message = 'Bu işlem geri alınamaz.',
    confirmText = 'Evet, Sil',
    cancelText = 'İptal',
    variant = 'danger',
    isLoading = false,
}) {
    const handleConfirm = () => {
        onConfirm?.();
    };

    const variantConfig = {
        danger: { icon: 'text-error', button: 'error' },
        warning: { icon: 'text-warning', button: 'warning' },
        primary: { icon: 'text-primary', button: 'primary' },
    };

    const config = variantConfig[variant] || variantConfig.danger;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size="sm"
            footer={
                <>
                    <Button variant="ghost" onClick={onClose} disabled={isLoading}>
                        {cancelText}
                    </Button>
                    <Button
                        variant={config.button}
                        onClick={handleConfirm}
                        isLoading={isLoading}
                    >
                        {confirmText}
                    </Button>
                </>
            }
        >
            <div className="flex items-start gap-4">
                <div className={`p-3 rounded-full bg-error-50 ${config.icon}`}>
                    <AlertTriangle size={24} />
                </div>
                <div className="flex-1">
                    <p className="text-text-primary">{message}</p>
                </div>
            </div>
        </Modal>
    );
}
